import { tenantColors } from './tenantColors';

const colors = {
  absoluteDark: '#000000',
  defaultGray: '#666666',
  appTextColor: '#FFFFFF',

  toast: {
    success: '#009656',
    error: '#E22F2F',
    text: '#FFFFFF',
  },

  appBg: {
    primaryBg: '#292935',
    secondaryBg: '#FFFFFF',
  },
  header: {
    border: 'rgba(255,255,255, 0.3)',
    logo: '#FFFFFF',
    text: '#FFFFFF',
    primaryBg: '#292935',
    secondaryBg: '#A01313',
  },
  navbar: {
    bg: '#292935',
    text: '#FFFFFF',
    selected: tenantColors.selected,
  },
  contestCard: {
    bg: '#FFFFFF',
    text: '#E22F2F',
    gradient: 'linear-gradient(90deg, rgba(0, 150, 86, 0) 0%, #009656 100%)',
  },
  cardSmall: {
    bg: '#292935',
    descriptionBg: tenantColors.descriptionBg,
    text: '#FFFFFF',
    buttonBg: '#FFFFFF',
    buttonBgActive: '#FFFFFF',
    gradient: 'linear-gradient(90deg, rgba(0, 150, 86, 0) 0%, #009656 100%)',
    title: '#FFFFFF',
    description: '#FFFFFF',
  },
  tile: {
    bg: 'linear-gradient(251deg, #1CFF47 -12.7%, #25BD95 103.67%)',
    text: '#111111',
  },
  contestTile: {
    bg: '#33CFFF',
    text: '#111111',
    liveText: '#FFFFFF',
    liveBg: tenantColors.liveBg,
  },
  userContestTile: {
    bg: '#3B3B54',
    text: '#FFFFFF',
    winBg: 'linear-gradient(251deg, #1CFF47 -12.7%, #25BD95 103.67%)',
    winText: '#292935',
  },
  timer: {
    bg: '#FFFFFF',
    text: '#19191C',
    image: '#666666',
    imageActive: '#E22F2F',
  },
  section: {
    title: '#FFFFFF',
    leftImage: {
      title: '#E22F2F',
      subtitle: '#E22F2F',
      description: '#E22F2F',
    },
  },
  carousel: {
    bullet: '#FFFFFF',
    bulletActive: '#FFFFFF',
  },
  langSwitcher: {
    bg: '#292935',
    icon: tenantColors.icon,
    border: '#A01313',
    text: '#FFFFFF',
  },
  input: {
    bg: '#3B3B54',
    border: '#88B3FF',
    text: '#FFFFFF',
    placeholder: '#8A8AB2',
    invalid: '#E22F2F',
    cancel: '#D9D9D9',
    hint: '#D9D9D9',
    success: '#009656',
    eye: '#D9D9D9',
  },
  checkbox: {
    label: '#FFFFFF',
    bg: '#3B3B54',
    icon: '#08F9AE',
  },
  signup: {
    title: '#FFFFFF',
    text: '#FFFFFF',
  },
  login: {
    title: '#FFFFFF',
    text: '#FFFFFF',
  },
  profile: {
    title: '#FFFFFF',
    text: '#FFFFFF',
  },
  resetPassword: {
    title: '#FFFFFF',
    text: '#FFFFFF',
  },
  forgotPassword: {
    title: '#FFFFFF',
    text: '#FFFFFF',
    success: '#009656',
  },
  unsubscribe: {
    title: '#FFFFFF',
    text: '#FFFFFF',
    iconButton: '#FFFFFF',
  },
  countrySelect: {
    bg: '#3B3B54',
    border: 'transparent',
    text: '#FFFFFF',
    menuBg: '#3B3B54',
    placeholder: '#8A8AB2',
    arrow: '#8A8AB2',
  },
  sidebar: {
    bg: '#292935',
    close: '#FFFFFF',
    logo: '#FFFFFF',
    text: '#FFFFFF',
    overlay: 'rgba(0, 0, 0, 0.40)',
  },
  button: {
    defaultText: '#FFFFFF',
    primary: {
      bg: 'linear-gradient(251deg, #67F482 -12.7%, #3BBB99 103.67%)',
      disabledBg: 'linear-gradient(180deg, #7BD46D 0%, #529248 100%)',
      text: '#FFFFFF',
      disabledText: 'rgba(7, 60, 28, 0.3)',
      activeBg: 'linear-gradient(250.85deg,#25bd95 -12.7%,#1cff47 103.67%)',
    },
    secondary: {
      bg: 'transparent',
      border: '#FFFFFF',
      disabledBg: 'transparent',
      text: '#FFFFFF',
      activeBg: '#FFFFFF',
      activeText: '#19191C',
    },
    outline: {
      border: '#1CFF47',
    },
  },
  navigation: {
    border: 'transparent',
    borderActive: tenantColors.borderActive,
    text: '#FFFFFF',
    background: '#292935',
  },
  desktopSideNavbar: {
    bg: '#292935',
    text: '#FFFFFF',
    textActive: tenantColors.textActive,
  },
  stepper: {
    background: '#19191C',
    activeColor: '#33CFFF',
    correct: '#08F9AE',
    incorrect: tenantColors.incorrect,
    color: '#FFFFFF',
    grey: 'rgba(241, 243, 245, 0.60)',
  },
  mobileStepper: {
    mainBg: '#19191C',
    buttonBg: '#292935',
  },
  scrollbar: {
    trackBg: '#19191C',
    thumbBg: 'rgba(241, 243, 245, 0.60)',
  },
  home: {
    questionBlockBg: '#173476',
    activeText: '#33CFFF',
    buttonText: '#073C1C',
  },
  prizes: {
    rulesBg: '#173476',
    prize: '#08F9AE',
  },

  playQuestion: {
    hintPrizeText: '#33CFFF',
    winPrizeText: '#08F9AE',
    bg: 'rgba(235, 235, 244, 0.10)',
    eliminatedText: tenantColors.eliminatedText,
  },

  playQuestionAnswered: {
    title: '#08F9AE',
    text: '#FFFFFF',
    prize: '#08F9AE',
    prizeBg: '#173476',
    optionBg: '#88B3FF',
    optionText: '#19191C',
  },

  pickSaved: {
    hintNoPrize: '#33CFFF',
  },

  history: {
    background: '#292935',
    incorrect: tenantColors.incorrect,
    correct: '#08F9AE',
    incorrectBorder: tenantColors.incorrect,
    correctBorder: '#88B3FF',
    defaultBorder: '#3B3B54',
  },

  gradientCasino: tenantColors.gradientCasino,
  answerButton: {
    bg: '#1B1B1B',
    disabledBg: '#5c5c5c',
    activeBg: '#88B3FF',
    correctBg: '#08F9AE',
    incorrectBg: tenantColors.incorrectBg,
    dark_text: '#19191C',
    white_text: '#ffffff',
    disabled_text: '#bfbfbf',
    border_color: '#88B3FF',
    iconBg: 'rgba(95, 95, 122, 0.50)',
    activeIconBg: 'rgba(97, 146, 216, 0.50)',
  },

  modal: {
    bg: '#88B3FF',
    overlayBg: 'rgba(0, 0, 0, 0.40)',
    title: '#111111',
    text: '#FFFFFF',
  },

  table: {
    bg: '#292935',
    nonPairRow: '#292935',
    pairRow: '#1B1B1B',
    currentUserBg: '#316EF7',
    text: '#FFFFFF',
  },
};

export default colors;
